class WishlistDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('#WishlistDrawer');
    this.overlay = this.querySelector('#WishlistDrawer-Overlay');
    this.closeButton = this.querySelector('.drawer__close');
    this.emptyState = this.querySelector('#WishlistDrawer-Empty');
    this.contentsState = this.querySelector('#WishlistDrawer-Contents');
    this.itemsWrapper = this.querySelector('#WishlistDrawer-Items');
    this.headerIcon = document.querySelector('#wishlist-icon-bubble');

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
    
    // Close when clicking the dark background overlay
    this.addEventListener('click', (e) => {
      if (e.target === this || e.target.id === 'WishlistDrawer') {
        this.close();
      }
    });

    if (this.headerIcon) {
      this.headerIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }
    
    document.addEventListener('wishlist:updated', this.renderContents.bind(this));
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    this.renderContents();
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  renderContents() {
    const handles = Wishlist.get();
    
    // Update badge count
    const badge = document.querySelector('#wishlist-count-bubble');
    if (badge) {
      if (handles.length > 0) {
        badge.classList.remove('hidden');
        badge.querySelector('span[aria-hidden="true"]').textContent = handles.length;
      } else {
        badge.classList.add('hidden');
      }
    }

    if (handles.length === 0) {
      this.classList.add('is-empty');
      if (this.emptyState) this.emptyState.style.display = 'block';
      if (this.contentsState) this.contentsState.style.display = 'none';
      return;
    }

    this.classList.remove('is-empty');
    if (this.emptyState) this.emptyState.style.display = 'none';
    if (this.contentsState) this.contentsState.style.display = 'block';

    this.itemsWrapper.innerHTML = '<div class="loading-overlay__spinner" style="width: 100%; display: flex; justify-content: center; padding: 2rem;"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
    
    const rootUrl = window.Shopify.routes.root === '/' ? '/' : window.Shopify.routes.root + '/';
    
    Promise.all(handles.map(handle => 
      fetch(`${rootUrl}products/${handle}?section_id=wishlist-card`)
        .then(res => {
          if (!res.ok) throw new Error('Product not found');
          return res.text();
        })
        .catch(err => {
           console.error(err);
           Wishlist.remove(handle, false);
           return '';
        })
    )).then(htmlArray => {
      this.itemsWrapper.innerHTML = '';
      htmlArray.forEach(html => {
        if (!html) return;
        const div = document.createElement('div');
        div.innerHTML = html;
        const item = div.querySelector('.wishlist-item');
        if (item) {
          this.itemsWrapper.appendChild(item);
          const removeBtn = item.querySelector('[data-wishlist-remove]');
          if (removeBtn) {
            removeBtn.addEventListener('click', (e) => {
              e.preventDefault();
              Wishlist.remove(item.dataset.productHandle);
            });
          }
        }
      });
    });
  }
}

customElements.define('wishlist-drawer', WishlistDrawer);


const Wishlist = {
  key: 'theme:wishlist',
  get() {
    try {
      const items = localStorage.getItem(this.key);
      return items ? JSON.parse(items) : [];
    } catch (e) {
      return [];
    }
  },
  add(handle) {
    let items = this.get();
    if (!items.includes(handle)) {
      items.push(handle);
      localStorage.setItem(this.key, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
  },
  remove(handle, triggerEvent = true) {
    let items = this.get();
    items = items.filter(i => i !== handle);
    localStorage.setItem(this.key, JSON.stringify(items));
    if (triggerEvent) {
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
  },
  has(handle) {
    return this.get().includes(handle);
  },
  toggle(handle) {
    if (this.has(handle)) {
      this.remove(handle);
      return false;
    } else {
      this.add(handle);
      const drawer = document.querySelector('wishlist-drawer');
      if (drawer) drawer.open();
      return true;
    }
  }
};

window.Wishlist = Wishlist;

document.addEventListener('DOMContentLoaded', () => {
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
});

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.productHandle;
    this.button = this.querySelector('button');
    
    if (this.button) {
      this.button.addEventListener('click', () => {
        Wishlist.toggle(this.handle);
      });
    }

    this.boundUpdateState = this.updateState.bind(this);
  }

  connectedCallback() {
    document.addEventListener('wishlist:updated', this.boundUpdateState);
    this.updateState();
  }

  disconnectedCallback() {
    document.removeEventListener('wishlist:updated', this.boundUpdateState);
  }

  updateState() {
    if (!this.button) return;
    if (Wishlist.has(this.handle)) {
      this.button.classList.add('is-active');
      this.button.setAttribute('aria-pressed', 'true');
    } else {
      this.button.classList.remove('is-active');
      this.button.setAttribute('aria-pressed', 'false');
    }
  }
}
customElements.define('wishlist-button', WishlistButton);
